import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Copy, GraduationCap, Monitor, MessageSquare } from 'lucide-react';
import { Card } from '../../ui/card';

const iconMap = {
  ShieldCheck,
  Copy,
  GraduationCap,
  Monitor,
  MessageSquare,
};

const ProductSlide = ({ data }) => {
  return (
    <div className="w-full max-w-6xl mx-auto">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-10"
      >
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">{data.title}</h2>
        <p className="text-xl text-slate-400">{data.subtitle}</p>
      </motion.div>

      {/* Product Cards */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        {data.products.map((product, index) => {
          const Icon = iconMap[product.icon];
          const colors = [
            'from-cyan-500/20 to-cyan-600/20 border-cyan-500/30',
            'from-teal-500/20 to-teal-600/20 border-teal-500/30',
            'from-emerald-500/20 to-emerald-600/20 border-emerald-500/30',
            'from-sky-500/20 to-sky-600/20 border-sky-500/30',
            'from-blue-500/20 to-blue-600/20 border-blue-500/30',
          ];
          const iconColors = ['text-cyan-400', 'text-teal-400', 'text-emerald-400', 'text-sky-400', 'text-blue-400'];
          
          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 + index * 0.1 }}
            >
              <Card className={`bg-gradient-to-br ${colors[index]} p-5 h-full text-center hover:scale-105 transition-transform`}>
                <div className="flex flex-col items-center">
                  <div className="w-10 h-10 rounded-full bg-slate-900/50 flex items-center justify-center mb-3 text-lg font-bold text-white">
                    {index + 1}
                  </div>
                  <div className="p-3 bg-slate-900/30 rounded-xl mb-3">
                    <Icon className={`w-7 h-7 ${iconColors[index]}`} />
                  </div>
                  <h3 className="text-base font-semibold text-white mb-2">{product.name}</h3>
                  <p className="text-sm text-slate-300">{product.desc}</p>
                </div>
              </Card>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductSlide;
